export default "__VITE_ASSET__6jGHWviY__"